export var ACCESS_TOKEN_KEY = 'access';
export var HOTKEYS = 'E-PACS-HOTKEYS';
export var REFRESH_TOKEN_KEY = 'refresh';
export var ORGANIZATION_ID_KEY = 'oid';
export var I18N_LANGUAGE_KEY = 'i18nLng';
